import { Form, Button, Spin, Empty, Input } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { connect, useSelector } from 'react-redux';
import SelectInput from 'src/components/shared/selectInput';
import { validateContentRules } from 'src/utils/custom.validator';
import apicallsForCases from './api';
import apiCalls from 'src/api/apiCalls';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { commonErrorMsg } from 'src/utils/errorConstants';
import { success } from 'src/utils/message';
import ErrorMessage from 'src/components/shared/messages/errorMessage';
import HeaderComponent from 'src/components/header';
import { isErrorMessage } from 'src/components/shared/error.message';
const { TextArea } = Input;
let controllers = {
    customerscreatecase: {
        endPoint: 'customer',
        type: 'Customer'
    },
    cardtransactionscreatecase: {
        endPoint: "transaction",
        type: 'Transaction'
    },
    payeescreatecase: {
        endPoint: "payees",
        type: 'Payee'
    }
}
 
const CreateCase = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const user = useSelector(state => state.oidc?.user.currentUser)
    const [caseFormData, setcaseFormData] = useState({
        toggleModel: false,
        remarks: '',
        adminsData: [],
        assignedTo: [],
        templateData: [],
        customerData: {},
        commonModel: {},
        caseDetails: [],
        selectedTemplateName: '',
        caseNumber: '',
        isAdmin: null,
        caseState: '',
        assignedRemarks: '',
        checked: false,
        errorMsg: null,
        loader: false,
        saveBtn: false,
        isReqforDoc: false,
        modules: [],
        note: ""
    });
    const { id } = useParams();
    const location = useLocation();
    const currentPath = location?.pathname?.replace(/\//g, '');
    const pathWithoutId = currentPath.replace(/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/i, '');
    const controller = controllers[pathWithoutId];
    const dynamicBreadCrumbList = useMemo(() => {
        if (currentPath.includes('customers')) {
            return [
                { id: '1', bname: 'Customers', url: '/customers' },
                { id: '2', bname: 'Create Case', url: '' }
            ];
        } else if (currentPath.includes('cardtransactions')) {
            return [
                { id: '1', bname: 'Transactions', url: '/cardtransactions' },
                { id: '2', bname: 'Create Case', url: '' }
            ];
        } else {
            return [
                { id: '1', bname: 'Create Case', url: '' }
            ];
        }
    }, [currentPath]);
    useEffect(() => {
        const fetchAllData = async () => {
            setcaseFormData(prevState => ({
                ...prevState,
                loader: true
            }));
            await Promise.all([customerAllData(), assignedAdmins(), templateDataLu(), modulesDataLu()]);
            setcaseFormData(prevState => ({
                ...prevState,
                loader: false
            }));
        };
        fetchAllData();
    }, []);
    const modulesDataLu = async () => {
        try {
            const response = await apiCalls.casesModules();
            if (response.ok) {
                setcaseFormData(prevSate => ({
                    ...prevSate,
                    modules: response.data?.CaseModules
                }));
                form.setFieldsValue({ Module: "Cards" });
            } else {
                setcaseFormData(prevState => ({
                    ...prevState,
                    errorMsg: apiCalls.isErrorDispaly(response),
                }))
            }
        } catch (err) {
            setcaseFormData(prevState => ({
                ...prevState,
                errorMsg: commonErrorMsg,
            }));
        }
    };
    const handleSubmit = useCallback(async () => {
        const values = form.getFieldsValue();
        try {
            const postData = {
                id: "00000000-0000-0000-0000-000000000000",
                caseNumber: caseFormData?.caseNumber,
                isAdmin: caseFormData?.isAdmin,
                caseTitle: values?.caseTitle,
                appName: values?.Module,
                assignedTo: [],
                commonModel: caseFormData?.commonModel,
                remarks: values?.customerRemarks || '',
                state: caseFormData?.caseState,
                createdDate: new Date(),
                createdBy: user.userName,
                modifiedDate: user.modifiedDate || null,
                modifiedBy: user.modifiedBy || null,
                caseDetails: [{
                    "id": "00000000-0000-0000-0000-000000000000",
                    "caseId": null,
                    "isChecked": true,
                    "documentName": null,
                    "state": null
                }],
                customerCaseTitle: values["caseTitle"],
                isCustomerDocument: caseFormData?.checked,
                templateName: values?.templateName || "",
                isReqforDoc: caseFormData?.isReqforDoc,
                type: controller.type,
                typeId: id,
                note: caseFormData?.note
            };
            const response = await apicallsForCases.createCase(postData);
            if (response.ok) {
                success("Case details saved successfully");
                if (pathWithoutId.includes("customerscreatecase")) {
                    navigate("/customers");
                } else if (pathWithoutId.includes("cardtransactionscreatecase")) {
                    navigate("/cardtransactions");
                } else {
                    navigate('/payees');
                }
            } else {
                setcaseFormData((prevState) => ({
                    ...prevState,
                    errorMsg: isErrorMessage(response?.data)
                }));
            }
        } catch (error) {
            setcaseFormData((prevState) => ({ ...prevState, errorMsg: commonErrorMsg }));
        } finally {
            setcaseFormData((prevState) => ({
                ...prevState,
                saveBtn: false
            }));
        }
    }, [form, caseFormData, user, controller, id, pathWithoutId, navigate]);


    const handleRemarkChange = useCallback((e) => {
        const { value } = e.target;
        setcaseFormData((prevState) => ({
            ...prevState,
            note: value
        }));
    }, [])
    const assignedAdmins = async () => {
        try {
            setcaseFormData(prevState => ({
                ...prevState,
                loader: true
            }));
            const response = await apicallsForCases.assignAdmins();
            if (response.ok) {
                setcaseFormData(prevSate => ({
                    ...prevSate,
                    adminsData: response.data
                }))
            } else {
                setcaseFormData(prevState => ({
                    ...prevState,
                    errorMsg: apiCalls.isErrorDispaly(response)
                }))
            }
            setcaseFormData(prevState => ({
                ...prevState,
                loader: false
            }));
        }
        catch (err) {
            setcaseFormData(prevState => ({
                ...prevState,
                errorMsg: commonErrorMsg
            }));
        }
    }
    const customerAllData = async () => {
        try {
            setcaseFormData(prevState => ({ ...prevState, loader: true }));
            const response = await apicallsForCases.adminData(id, controller?.endPoint, true);
            if (response.ok) {
                setcaseFormData(prevSate => ({
                    ...prevSate,
                    customerData: response.data, commonModel: response.data?.commonModel, caseDetails: response.data?.caseDetails, caseNumber: response.data?.caseNumber, caseState: response?.data?.state, isAdmin: response?.data?.isAdmin
                }))
            } else {
                setcaseFormData(prevState => ({
                    ...prevState,
                    errorMsg: apiCalls.isErrorDispaly(response)
                }))
            }
            setcaseFormData(prevState => ({ ...prevState, loader: false }));
        } catch (err) {
            setcaseFormData(prevState => ({
                ...prevState,
                errorMsg: commonErrorMsg
            }));
        }
    }
    const templateDataLu = async () => {
        try {
            const response = await apicallsForCases.casesTemplate();
            if (response.ok) {
                setcaseFormData(prevSate => ({
                    ...prevSate,
                    templateData: response.data
                }))
            } else {
                setcaseFormData(prevState => ({
                    ...prevState,
                    errorMsg: apiCalls.isErrorDispaly(response)
                }))
            }
        } catch (err) {
            setcaseFormData(prevState => ({
                ...prevState,
                errorMsg: commonErrorMsg
            }));
        }
    };
    const handleCancle = useCallback(() => {
        if (pathWithoutId.includes("customerscreatecase")) {
            navigate("/customers");
        } else if (pathWithoutId.includes("cardtransactionscreatecase")) {
            navigate("/cardtransactions");
        } else {
            navigate('/payees');
        }
    }, [pathWithoutId, navigate]);
    const closeError = useCallback(() => {
        setcaseFormData(prevState => ({
            ...prevState,
            errorMsg: null
        }))
    }, [])
    return (
        <div className=''>
            <HeaderComponent breadCrumbList={dynamicBreadCrumbList} />
            {caseFormData.errorMsg !== undefined && caseFormData.errorMsg !== null && (
                <ErrorMessage msg={caseFormData.errorMsg} onClose={closeError} />
            )}
            <Form
                form={form}
                autoComplete="off"
                className="custom-input-field"
                onFinish={handleSubmit}
            >
                <Spin spinning={caseFormData.loader}>
                    <div className='border border-StrokeColor rounded-5 p-4'>
                        <div className='grid md:grid-cols-3 gap-4 cases-user-input'>
                            <div className=''>
                                <p className='summary-label'>Case Number</p>
                                <p className='summary-value'>{caseFormData.caseNumber}</p>
                            </div>
                            <div className="custom-user-input">
                                <Form.Item
                                    name={"caseTitle"}
                                    className="custom-input mb-0"
                                    label="Case Title"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Is required",
                                            whitespace: true
                                        },
                                        {
                                            validator: validateContentRules
                                        }
                                    ]}
                                >
                                    <Input className="w-full appearance-none "
                                        placeholder="Case Title"
                                        maxLength={30} />
                                </Form.Item>
                            </div>
                            <div className="custom-user-input">
                                <Form.Item
                                    name={"Module"}
                                    className="custom-input mb-0"
                                    label={"Modules"}
                                    rules={[
                                        { required: true, message: "Is required" }
                                    ]}
                                >
                                    <SelectInput allowClear={false} showSearch={false} defaultValue='Cards' fieldName="Modules" optionValue="name" optionLabel="name" options={caseFormData?.modules} customClass="!pt-0 !rounded-5" />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Spin>
                <div className='border border-StrokeColor rounded-5 p-4 mt-7'>
                    <Spin spinning={caseFormData.loader}>
                        <div className='grid md:grid-cols-4 gap-4'>
                            {caseFormData.commonModel === null && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                            {caseFormData.commonModel !== null && Object.entries(caseFormData.commonModel).map(([key, value], idx) => (
                                <div className='flex items-center gap-1.5' key={key}>
                                    <div>
                                        <span className={`icon ${key.toLowerCase()}-icon`}></span>
                                    </div>
                                    <div>
                                        <p className='summary-label'>{key}</p>
                                        <p className='summary-value'>{value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Spin>
                </div>
                <div className='border border-StrokeColor rounded-5 p-4 mt-7 grid md:grid-cols-2 gap-4'>
                    <div className='custom-user-input'>
                        <Form.Item
                            className="custom-input mb-0"
                            name="note"
                            label='Note'
                            rules={[
                                {
                                    required: true, message: 'Is required'
                                },
                                {
                                    whitespace: true
                                },
                                {
                                    validator: validateContentRules
                                }
                            ]}
                        >
                            <TextArea rows='3' placeholder='Write Note' className="!bg-transparent rounded-5" value={caseFormData.note} onChange={handleRemarkChange} maxLength={400}/>
                        </Form.Item>
                    </div>
                </div>
                <div className='mt-5 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                    <Button type="cancel" className='cancel-btn me-2' onClick={handleCancle}>Cancel</Button>
                    <Button type="primary" key="submit" htmlType="submit" className="primary-btn" loading={caseFormData.saveBtn}>Save</Button>
                </div>
            </Form>
        </div>
    )
}
const connectStateToProps = ({ userConfig, oidc }) => {
    return { userConfig: userConfig?.userProfileInfo, user: oidc?.user, trackAuditLogData: oidc?.trackAuditLogData };
}
export default connect(connectStateToProps)(CreateCase);